const {FetchRequest} = require('data-fetcher/data-fetcher')

function getResponseMap() {
    const data = this.responseMap;
    const dsData = data && data[this.datasourceName];
    return dsData.data || dsData;
}

class DataLoaderFetchRequest extends FetchRequest {
    constructor (req, requestKey, requestUrl, datasource, params) {
        super(req, requestKey, requestUrl, datasource, params);
        const fetchConfig = this.fetchConfig;
        fetchConfig.expires = this.expires;
        fetchConfig.timeout = this.timeout;
        // Turn off memory storage 
        // Maybe make this configurable in the future
        this.store = false;
        this.datasourceName = datasource.name;
    }

    fetchData (fetchResponse) {
        fetchResponse.ok = fetchResponse.isOk;
        fetchResponse[this.fetchType] = getResponseMap;
        fetchResponse.datasourceName = this.datasource.name;
        return super.fetchData(fetchResponse);
    }

    fetch (url, fetchConfig) {
        return DataLoaderFetchRequest.fetch(url, fetchConfig, this);
    }
}

module.exports = DataLoaderFetchRequest;